import { auth, db, FIRESTORE_ID } from '../../plugins/firebase'
import Api from '../../api'

const state = {
    selected: null,
    list: [],
}

const getters = {}

const actions = {
    async init({ dispatch, rootState, commit }) {
        const collection = await db
            .collection(`${FIRESTORE_ID}/${rootState.account.id}/projects`)
            .get()
        const projects = collection.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }))
        const initial = projects.find((project) => project.initial)
        commit('SET_PROJECTS', projects)

        await dispatch('setProject', initial.id)
    },
    async setProject({ commit, dispatch, state }, project_id) {
        const project = state.list.find((p) => p.id === project_id)

        Api.setProject(project_id)
        commit('UPDATE_SELECTED', project)

        await dispatch('gateways/setNotReady', null, { root: true })
        await dispatch('meters/setNotReady', null, { root: true })
        await dispatch('gateways/init', null, { root: true })
        await dispatch('meters/init', null, { root: true })
    },
    async setInitialProject({ commit, state, rootState }, project_id) {
        const old_initial = state.list.find( p => p.initial )

        await db.doc(
            `${FIRESTORE_ID}/${rootState.account.id}/projects/${old_initial.id}`
        ).update({ initial: false })

        await db.doc(
            `${FIRESTORE_ID}/${rootState.account.id}/projects/${project_id}`
        ).update({ initial: true })

        commit('SET_INITIAL', {
            old: old_initial.id,
            new: project_id
        })
    },
}

const mutations = {
    SET_PROJECTS(state, projects) {
        state.list = projects
    },
    UPDATE_SELECTED(state, project) {
        state.selected = project
    },
    SET_INITIAL(state, payload) {
        const old_index = state.list.findIndex( p => p.id === payload.old )
        const new_index = state.list.findIndex( p => p.id === payload.new )
        
        const old_initial = state.list[old_index]
        const new_initial = state.list[new_index]
        
        old_initial.initial = false
        new_initial.initial = true
        
        state.list.splice(old_index, 1, old_initial)
        state.list.splice(new_index, 1, new_initial)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
